<template lang="pug"
src='./information.pug'>

</template>

<script>
import {EventBus} from '@/common/event-bus'
import saveBtn from '@/common/components/saveBtn.vue'
export default {
	name: 'information',
	props: ['project', 'control', 'readonly'],
	components: {
		saveBtn
	},
	data () {
		return {
			stories: [1, 2, 3, 4, 5],
			projType: {}
		}
	},
	methods: {
		showModalFromInfo (value) {
			EventBus.$emit('open-type-building-popUp', value)
		},
		getCondArea () {
			if (!this.project.totalCondArea || this.project.totalCondArea.length <= 0) {
				this.project.totalCondArea = [0, 0, 0, 0]
				this.project.totalCondArea.map(res => {
					this.project.totalCondArea[res] = 0
				})
			}
		}
	},
	created () {
		this.projType = process.env.PROJTYPE
		this.getCondArea()
	}
}
</script>



// WEBPACK FOOTER //
// src/app/take-off-tool/tabs-components/information.vue